import React from "react";
import { FiMapPin } from "react-icons/fi";
import Logo from "../styles/Black-SVG-Landscape.svg";
import JuanEstebanPhoto from "../candidates/danielaU.jpg"

export default function SocialMediaCreativeStrategistDaniela() {
  const candidateProfileCopy = {
    name: "Daniela",
    location: "Bogotá, Colombia",
    compensation: {
      range: "$18 USD / hourly",
    },
    availability: "Available to start immediately",

    working_style:
      "Daniela is a brand-first creative strategist who builds brand systems (voice, visual language, personality, tone) and designs content strategies that flow from that foundation. She has managed 15+ client accounts across North America, managed a Shopify e-commerce platform with CRO and SEO optimization, and brings specialized education in strategic brand management. Her approach is design-led, which is a genuine asset for building Frizo and LGO's visual identity from zero and making it extensible to future launches.",

    loom_video_link: "https://fathom.video/share/z2HPdAJq18ouaSoesdp7xEdY45PUZKbn",

    tools: [
      {
        category: "Brand Strategy & Visual Identity",
        items: [
          "Brand identity conceptualization: voice, personality, archetypes, visual language, tone guidelines",
          "Rebranding execution and extensible brand system design, built to scale across multiple brands",
          "Market analysis for consumer trends, competitive positioning, and brand differentiation",
          "Buyer persona definition and brand communication strategy (SM toolkits, messaging frameworks)",
        ],
      },
      {
        category: "Design & Content Production",
        items: [
          "Adobe Creative Suite, Figma, Canva (professional-grade design across static and digital formats)",
          "CapCut (short-form video editing for Reels, Shorts, TikTok)",
          "Branded carousels, infographic posts, product imagery, campaign creative, and landing pages",
          "Shopify (e-commerce platform management, digital merchandising, storefront design)",
        ],
      },
      {
        category: "Platforms & Performance",
        items: [
          "Instagram, TikTok, Meta Business Suite (organic and paid campaign management)",
          "Sprout Social, Hootsuite (scheduling, KPI reporting, cross-platform analytics)",
          "Google Analytics, Google Trends, Hypeauditor (audience insights, trend research, influencer analysis)",
          "Meta Ads (campaign launch, optimization, A/B/C testing to isolate graphic vs. copy performance)",
        ],
      },
      {
        category: "AI Tools & Workflow",
        items: [
          "Claude (preferred), ChatGPT, Gemini (content research, ideation, copy drafts, trend discovery)",
          "Midjourney, Leonardo (AI image generation for creative concepts and visual exploration)",
        ],
      },
    ],

    soft_skills: [
      "Specialized education in Strategic Brand Management (La Sabana) and branding (IE Business School)",
      "Conceptualized and designed 13 brand identities including voice, visual language, and communication strategy",
      "Managed 15+ client accounts across North America, recognized as top-performing specialist for KPI delivery",
      "Design-led thinker: approaches content through brand archetypes, emotional connection, and visual systems",
      "Cross-category trend intelligence: adapts ideas from outside the niche to create disruptive content",
      "Bilingual (English C1 / Spanish native) with professional use in North American client-facing environments",
    ],

    about_candidate:
      "Daniela has the deepest visual identity capability in this candidate group. She has built 13 brand identities from scratch, managed 15+ North American client accounts, and delivered a measurable 45% engagement increase through data-driven content optimization. She holds specialized education in Strategic Brand Management from IE Business School and currently manages a Shopify e-commerce platform with CRO and SEO optimization. She builds the voice, visual language, and personality first, then designs content that flows from that foundation. For a role that requires building a recognizable brand from zero, her design depth is a genuine differentiator.",

    core_strengths: [
      {
        headline: "Deepest visual identity and brand design capability in this group",
        description:
          "Has built 13 brand identities and designed across every channel: social, email, websites, ads, and landing pages. What she builds for the first brand becomes the infrastructure for every brand that follows.",
      },
      {
        headline: "Measurable 45% engagement increase at a North American agency",
        description:
          "Delivered a 45% engagement increase at Digital Resource managing 15+ client accounts across North America. Recognized as a top-performing specialist. Most concrete professional performance result in this group.",
      },
      {
        headline: "Shopify e-commerce and CRO experience adds DTC relevance",
        description:
          "Currently manages a Shopify platform including merchandising, storefront optimization, CRO, and SEO. Understands how content connects to product pages and how brand design drives purchasing decisions online.",
      },
      {
        headline: "Cross-category trend intelligence for disruptive content",
        description:
          "Described consuming trends from outside the industry and adapting them to create content that stands out because it's unexpected. Aligned with the role's emphasis that the best ideas for Frizo might come from a food or fitness brand, not just hemp.",
      },
    ],

    relevant_experience: [
      {
        headline: "Senior Social Media Strategist | Digital Resource | March 2024 to May 2024",
        bullets: [
          "Led multi-channel brand and marketing design projects including websites, paid social, organic content, and landing pages",
          "Launched and optimized paid campaigns across Meta platforms for lead generation",
          "Increased average client engagement by 45% through data-driven content optimization",
          "Managed 15+ client accounts across North America, recognized as top-performing specialist",
        ],
      },
      {
        headline: "Graphic Designer & E-commerce Assistant | Mercado Global | May 2024 to Present",
        bullets: [
          "Manages Shopify platform including product merchandising, storefront optimization, and digital marketing",
          "Applies CRO and SEO knowledge to increase conversion rates based on Google Analytics data",
          "Creates brand-specific content design strategies maintaining visual consistency across channels",
          "Increased revenue and performance of the Shopify platform in collaboration with the director",
        ],
      },
      {
        headline: "Brand Manager | Soins Karismä (SaaS Startup) | August 2023 to February 2024",
        bullets: [
          "Created and executed comprehensive brand strategy for a B2B and B2C business model",
          "Developed and implemented a full rebranding across the organization improving consumer perception",
          "Led the marketing team on communication strategies across different channels",
        ],
      },
      {
        headline: "Social Media and Design Manager | Aoro (Finance/Crypto) | March 2024 to May 2024",
        bullets: [
          "Created and executed social media strategy according to brand and commercial objectives",
          "Defined target audience and buyer personas, built brand communication strategy and SM toolkit",
          "Implemented paid and organic campaigns using Hypeauditor, Google Trends, Analytics, and UGC",
        ],
      },
      {
        headline: "Head of Design | Leyla Creatives Agency | July 2021 to April 2022",
        bullets: [
          "Conceptualized and designed the identity of 13 brands and visual elements for various assets",
          "Led the creative team and executed brand strategies through market research",
          "Analyzed data and insights to determine market trends and design positioning strategies",
        ],
      },
    ],
  };

  const technicalAssessment = {
    meta: {
      role: "Social Media Creative Strategist, Frizo / LGO Brands",
      interviewDate: "March 16, 2026",
      analyst: "AI-Architechs Senior Technical Hiring Analysis",
    },

    snapshot:
      "Daniela brings the deepest visual identity and brand design capability in this group. She's built 13 brand identities, delivered a 45% engagement increase managing 15+ North American client accounts, and understands funnel architecture. Her profile is strongest on brand design, and her scripting and hook writing depth is worth exploring in conversation. A strong #2 whose visual identity strength fills a genuine need for what Frizo and LGO are building.",

    scorecard: [
      {
        dimension: "Content Production & Visual Identity",
        score: 8,
        rationale:
          "Strongest visual identity capability in this group. Built 13 brand identities and produces across ads, landing pages, email, social, and web. Uses Adobe Creative Suite, Figma, and CapCut. Her static creative and brand system design is elite-level here. Video editing depth is less evidenced than her design work. Scores equal to Keisy because her design ceiling is higher while Keisy's video production is stronger.",
      },
      {
        dimension: "Content-to-Subscriber Pipeline Thinking",
        score: 6,
        rationale:
          "Understands funnels conceptually and mentioned CTAs, discount incentives, and SEO keyword strategies. Her email conversion thinking covers the basics, though her natural orientation is toward brand building rather than the layered subscriber conversion mechanics that sit at the center of this role's #1 metric.",
      },
      {
        dimension: "Full-Funnel Content Strategy",
        score: 7,
        rationale:
          "Correctly mapped the three funnel layers with appropriate content types and metrics. Mentioned iterating with A/B/C testing. Solid framework knowledge that shows she understands how the pieces connect.",
      },
      {
        dimension: "Scripting, Hook Writing & Copywriting",
        score: 5,
        rationale:
          "Mentioned curiosity-based hooks and bold statements at a high level but didn't walk through concrete examples or describe her scripting process in detail. Email copywriting isn't highlighted on her CV. Worth exploring in conversation since her design instincts are strong and her writing process may be more developed than the interview format allowed her to show.",
      },
      {
        dimension: "Founder Coaching & On-Camera Direction",
        score: 6,
        rationale:
          "Suggested batch filming sessions, preparing scripts beforehand, and real-time remote feedback during recording. Also mentioned UGC creators to add content variety. The role's primary focus is developing Chad as on-camera talent, so her approach to coaching a non-professional founder is worth exploring further.",
      },
      {
        dimension: "Competitive Research & Cross-Category Intelligence",
        score: 7,
        rationale:
          "Described analyzing competitors across categories, studying Meta Ad Library, and consuming cross-industry trends. Stated that adapting trends from outside the industry creates content that stands out. Well aligned with the role's cross-category intelligence requirement.",
      },
      {
        dimension: "Metrics Accountability & Performance Optimization",
        score: 7,
        rationale:
          "Named all three core metrics and understood their interconnected funnel logic. Uses A/B/C testing to isolate what needs improvement. Cited a specific 45% engagement increase at Digital Resource, the most concrete performance metric from a professional agency role in this group.",
      },
      {
        dimension: "Regulated/Restricted-Ad Industry Readiness",
        score: 4,
        rationale:
          "No experience in restricted-ad industries yet. The hemp and cannabis compliance landscape would be new territory. Manageable given her marketing instincts and brand strategy depth, but adds ramp-up time compared to candidates who've already navigated platform restrictions.",
      },
      {
        dimension: "AI Tools & Workflow Efficiency",
        score: 6,
        rationale:
          "Uses Claude (preferred), ChatGPT, Gemini for research and ideation. Uses Midjourney and Leonardo for image generation. Shows willingness to adopt new tools. Meets the role's bar for a pro-AI attitude without building advanced workflows.",
      },
    ],

    strengths: [
      {
        headline: "Strongest visual identity and brand design capability in this group",
        description:
          "Built 13 brand identities and designed across every channel. What she builds for the first brand becomes the infrastructure for every brand that follows. No other candidate matches this depth.",
      },
      {
        headline: "Most concrete professional performance result in the group",
        description:
          "45% engagement increase at Digital Resource managing 15+ North American client accounts. Recognized as top-performing specialist. The most specific, attributed performance result tied to a content strategy outcome at scale.",
      },
      {
        headline: "Shopify e-commerce and CRO experience adds direct DTC relevance",
        description:
          "Manages a Shopify platform with merchandising, CRO, SEO, and brand content strategy. Understands the DTC context: how content connects to product pages and how design drives purchasing decisions.",
      },
      {
        headline: "Cross-category trend intelligence",
        description:
          "Consumes trends from outside the industry and adapts them to create content that stands out because it's unexpected. Aligned with the idea that Frizo's best content ideas might come from completely outside the hemp space.",
      },
      {
        headline: "Top-tier brand strategy education",
        description:
          "Strategic Brand Management from La Sabana, branding from IE Business School (Spain), fashion marketing from Academy of Art University (California). The formal foundation behind her ability to build brand systems, not just design assets.",
      },
      {
        headline: "TikTok hook analysis tool awareness",
        description:
          "Referenced TikTok's built-in tools that analyze hook performance and predict engagement drop-off before publishing. A practical advantage for optimizing short-form content performance.",
      },
    ],

    flags: [
      {
        headline: "Scripting and hook writing depth is worth exploring in conversation",
        description:
          "Daily parts of this role. Her interview stayed high-level on these topics without concrete examples. Her design instincts are strong, so it's worth exploring how she approaches writing and scripting in a conversation with Chad.",
      },
      {
        headline: "Career trajectory has some gaps worth understanding",
        description:
          "Senior role at Digital Resource lasted about 2 months, and her current position is at the assistant level. Could have straightforward explanations. Worth understanding the context in conversation.",
      },
      {
        headline: "Restricted-ad industry experience would be new",
        description:
          "Hemp and cannabis compliance would be a learning curve. Her marketing instincts give her a strong foundation, but she'd be getting up to speed rather than bringing existing knowledge.",
      },
    ],

    when_to_hire: [
      "Visual identity and brand-building are weighted heavily, and you want a world-class aesthetic system for Frizo, LGO, and every future launch.",
      "Her brand thinking comes through clearly in conversation with Chad and the collaboration dynamic feels right.",
      "You value the 45% engagement increase and 15+ North American client accounts as evidence of repeatable performance.",
      "You see design depth as the foundation that makes everything look and feel like a real brand from the start.",
    ],

    when_to_be_cautious: [
      "Scripting, hook writing, and email copy are non-negotiable daily deliverables and you want to see more depth there.",
      "Restricted-ad industry experience is a priority.",
      "The career trajectory questions leave you uncertain about long-term commitment.",
    ],

    bottom_line:
      "Daniela is #2 in this group with the strongest visual identity and brand design capability by a clear margin. Her 45% engagement increase is the most concrete performance result any candidate cited. Scripting depth and restricted-ad experience are areas worth exploring in conversation. If Chad connects with her brand thinking, she has the design foundation to make these brands look world-class from the start.",
  };



  // Score pill helper
  const ScorePill = ({ score }) => {
    let bg = "#f97316";
    if (score >= 8) bg = "#22c55e";
    else if (score >= 6) bg = "#36D1FF";
    return (
      <span
        style={{ backgroundColor: bg }}
        className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full"
      >
        {score} / 10
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-[#01014C] text-white flex flex-col items-center py-10 px-4">

      {/* ===================== PAGE 1 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row relative">

        {/* LEFT COLUMN */}
        <aside className="relative md:w-1/3 bg-gradient-to-b from-[#01014C] via-[#0A0A80] to-[#36D1FF] p-8 flex flex-col items-center text-center overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[#36D1FF]/30 to-transparent"></div>

          {/* Avatar */}
          <div className="relative mb-4">
            <div className="absolute inset-0 rounded-full bg-[#36D1FF]/20 blur-2xl"></div>
            <img
              src={JuanEstebanPhoto}
              alt={candidateProfileCopy.name}
              className="relative w-36 h-36 rounded-full object-cover border-4 border-[#36D1FF] shadow-lg"
            />
          </div>

          {/* Name */}
          <h1 className="text-2xl font-semibold mb-1 text-[#FFFDFB]">
            {candidateProfileCopy.name}
          </h1>

          {/* Location */}
          <div className="flex items-center gap-2 text-[#E0F7FF] text-sm mb-6 opacity-90">
            <FiMapPin className="text-[#36D1FF]" />
            <span>{candidateProfileCopy.location}</span>
          </div>

          {/* Compensation */}
          <div className="bg-[#01014C] border border-[#36D1FF]/50 rounded-xl p-4 w-full text-left mb-4">
            <p className="text-[#B3E9FF] text-sm font-semibold uppercase mb-1">
              Compensation
            </p>
            <p className="text-[#36D1FF] text-lg font-bold">
              {candidateProfileCopy.compensation.range}
            </p>
          </div>

          {/* Availability */}
          <div className="bg-[#01014C] border border-[#36D1FF]/30 rounded-xl p-4 w-full text-left mb-6">
            <p className="text-[#E0F7FF] text-sm">
              {candidateProfileCopy.availability}
            </p>
          </div>

          {/* Video Intro */}
          {candidateProfileCopy.loom_video_link && (
            <div className="w-full mt-4">
              <a
                href={candidateProfileCopy.loom_video_link}
                target="_blank"
                rel="noreferrer"
                className="block w-full text-center font-semibold py-3 rounded-lg
                           bg-[#36D1FF] text-[#01014C]
                           hover:bg-[#5FE2FF]
                           transition-all duration-300"
              >
                🎥 Watch Interview
              </a>
            </div>
          )}


          {/* Tools */}
          <div className="w-full mt-8 mb-6 text-left">
            <h3 className="text-sm font-semibold mb-3 text-[#B3E9FF] uppercase">
              Tools
            </h3>
            {candidateProfileCopy.tools.map((group, i) => (
              <div key={i} className="mb-4">
                <p className="text-xs font-semibold text-[#36D1FF] mb-1 uppercase tracking-wide">
                  {group.category}
                </p>
                <ul className="space-y-1">
                  {group.items.map((tool, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-xs text-[#E0F7FF]/90 leading-snug"
                    >
                      <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#36D1FF] shrink-0" />
                      {tool}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Soft Skills */}
          <div className="w-full mb-6 text-left">
            <h3 className="text-sm font-semibold mb-2 text-[#B3E9FF] uppercase">
              Soft Skills
            </h3>
            <ul className="list-disc pl-5 space-y-1 text-[#E0F7FF] text-sm">
              {candidateProfileCopy.soft_skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>
          </div>

          {/* Logo */}
          <div className="w-full mt-8 flex justify-center">
            <img src={Logo} alt="AI-Architechs Logo" className="w-42 opacity-80" />
          </div>
        </aside>

        {/* RIGHT COLUMN */}
        <main className="flex-1 p-10 text-[#01014C] space-y-10">
          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              About this Candidate
            </h2>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {candidateProfileCopy.about_candidate}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Core Strengths
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {candidateProfileCopy.core_strengths.map((item, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold mb-1">{item.headline}</p>
                  <p className="text-sm text-gray-700">{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Relevant Experience
            </h2>
            <div className="space-y-6">
              {candidateProfileCopy.relevant_experience.map((exp, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold text-[#EB5D2A] mb-2">{exp.headline}</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-700">
                    {exp.bullets.map((b, j) => (
                      <li key={j}>{b}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>

      {/* ===================== PAGE BREAK BAND ===================== */}
      <div className="w-full py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="h-10 rounded-2xl bg-gradient-to-r from-[#01014C] via-[#0A0A80] to-[#36D1FF] opacity-70 shadow-[0_0_40px_#36D1FF20]" />
        </div>
      </div>

      {/* ===================== PAGE 2 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl pb-2">
        <main className="p-10 text-[#01014C]">
          <div className="border border-[#36D1FF]/25 rounded-2xl p-6 bg-white shadow-[0_0_12px_#36D1FF15]">

            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-6">
              <h2 className="text-2xl font-semibold text-[#01014C]">
                Technical Analysis
              </h2>
              <div className="flex flex-col items-start md:items-end gap-1 text-xs text-gray-400">
                <span>{technicalAssessment.meta.role}</span>
                <span>Interview: {technicalAssessment.meta.interviewDate}</span>
                <span>{technicalAssessment.meta.analyst}</span>
              </div>
            </div>

            {/* Snapshot */}
            <div className="border border-[#36D1FF]/20 rounded-xl p-5 bg-[#36D1FF]/5 mb-6">
              <p className="text-base font-bold text-[#01014C] mb-2">Executive Fit Snapshot</p>
              <p className="text-gray-700 text-base leading-relaxed whitespace-pre-line">
                {technicalAssessment.snapshot}
              </p>
            </div>

            {/* Strengths & Flags */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">

              {/* Strengths */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Strengths
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.strengths.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#22c55e]/30 rounded-xl p-4 bg-[#22c55e]/5"
                    >
                      <p className="font-semibold text-sm text-[#01014C] mb-1">
                        {item.headline}
                      </p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Flags */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Flags / Watch-outs
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.flags.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#f97316]/30 rounded-xl p-4 bg-[#f97316]/5"
                    >
                      <p className="font-semibold text-sm text-[#01014C] mb-1">
                        {item.headline}
                      </p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Scorecard */}
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                Quantitative Scorecard
              </h3>
              <div className="overflow-x-auto rounded-xl border border-[#36D1FF]/25">
                <table className="w-full text-sm">
                  <thead className="bg-[#36D1FF]/10 text-[#01014C]">
                    <tr>
                      <th className="text-left font-semibold px-4 py-3">Dimension</th>
                      <th className="text-left font-semibold px-4 py-3 w-[120px]">Score</th>
                      <th className="text-left font-semibold px-4 py-3">Rationale</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#36D1FF]/15">
                    {technicalAssessment.scorecard.map((row, idx) => (
                      <tr key={idx} className="bg-white">
                        <td className="px-4 py-3 font-medium text-[#01014C] align-top">
                          {row.dimension}
                        </td>
                        <td className="px-4 py-3 align-top">
                          <ScorePill score={row.score} />
                        </td>
                        <td className="px-4 py-3 text-gray-700 whitespace-pre-line align-top">
                          {row.rationale}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* When to Hire / Considerations */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">

              {/* When to Hire */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Hire Juan Esteban if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_hire.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#36D1FF]/30 rounded-xl p-4 bg-[#36D1FF]/5 text-sm text-gray-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* When to Be Cautious */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Be cautious or pass if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_be_cautious.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#f59e0b]/30 rounded-xl p-4 bg-[#f59e0b]/5 text-sm text-gray-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom Line */}
            <div className="border border-[#01014C]/20 rounded-xl p-5 bg-[#01014C]/5">
              <p className="text-sm font-bold text-[#01014C] mb-2 uppercase tracking-wide">
                🏁 Bottom Line
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                {technicalAssessment.bottom_line}
              </p>
            </div>

          </div>
        </main>
      </div>

    </div>
  );
}
